import b from 'b_';
import { useIntl, H2, Image, Button, SimpleText, SimpleCallback, Text } from 'platform-components';
import React from 'react';
import { useMedia } from 'react-use';

import './certificate-modal__success-letter.scss';

export const MEDIA_QUERY_TABLET = '(max-width: 1023px)';

interface SuccessLetterProps {
    email: string;
    onAccept: SimpleCallback;
}

export const CertificateModalSuccessLetter = ({ email, onAccept }: SuccessLetterProps) => {
    const intl = useIntl();
    const isTablet = useMedia(MEDIA_QUERY_TABLET);

    return (
        <div className={b('certificate-modal', 'success-letter')}>
            <Image
                alt={intl.formatMessage({ id: 'certificatesModal.success.imgAlt' })}
                className={b('certificate-modal', 'success-letter-image')}
                src={intl.formatMessage({ id: 'certificatesModal.success.imgSrc' })}
            />
            {isTablet ? (
                <Text
                    id="certificatesModal.success.letterHeader"
                    size={Text.SIZE.XL}
                    type={Text.TYPE.MARKDOWN}
                    values={{ email }}
                />
            ) : (
                <H2 id="certificatesModal.success.letterHeader" type={Text.TYPE.MARKDOWN} values={{ email }} />
            )}
            <Button className="certificate-modal__success-letter-button" onClick={onAccept}>
                <SimpleText id="certificatesModal.success.button" />
            </Button>
        </div>
    );
};
